import { action } from 'easy-peasy';
import { IActionSetAllClientOptionByTeam } from '../types';

const setAllClientOptionByTeams: IActionSetAllClientOptionByTeam = action((state, payload) => {
  state.clientOptionsByTeam.isAllSelected = payload;

  if (payload) {
    state.clientOptionsByTeam.current = state.clientOptionsByTeam.list;
  }
});

export default setAllClientOptionByTeams;
